export default __webpack_public_path__ + "static/media/balance-wellness-creation.b4fa7a3c.md";